module.exports = __webpack_public_path__ + "static/media/signup.12c8e60d.svg";